const styles = (theme: Object) => ({
  dialogCtr: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto'
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block'
  }
});

export default styles;
